import firebase from "firebase/app";
import "firebase/auth";
import axios from "axios";
import constants from "./../constants";
import { toStringFormat } from "./Utils";

export const uploadCustomerInfo = async (data) => {

  const formData = new FormData();
  formData.append("phoneNumber", data.phoneNumber);
  formData.append("firstName", data.firstName);
  formData.append("lastName", data.lastName);  
  formData.append("cinNumber", data.cinNumber);  
  formData.append("cinFront", data.cinFront);  
  formData.append("cinBack", data.cinBack);  
  formData.append("selfie", data.selfie); 

  const token = await firebase.auth().currentUser.getIdToken();
  
  let url = constants.KYC_API;
  try {
    const response = await axios.post(`${url}saveCustomerInfo`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'multipart/form-data',
      },
    });
    if (response.status === 200 && response.data.success == true) {
      alert('Les informations ont été enregistrées avec succès')
    }
    else{
        alert('Une erreur s\'est produite, réessayez')
    }
  } catch (e) {
    alert('Une erreur s\'est produite, réessayez')
    return false;
  }

  return [];
};


export const createVerificationLink = async (phoneNumber) => {
 

  const token = await firebase.auth().currentUser.getIdToken();
  
  let url = constants.KYC_API;
  var payload = {
    phoneNumber : phoneNumber
  }
  try {
    const response = await axios.post(`${url}verification`,payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': '*',
      },
    });
    if (response.status === 200 && response.data.success == true) {
      console.log(response.data);
      return response.data;
    }
    else{
        alert('Une erreur s\'est produite, réessayez')
        return false
    }
  } catch (e) {
    alert('Une erreur s\'est produite, réessayez')
    return false;
  }

  return [];
};
